const Form002TC = {
    stepName: {
        ImportantNotes: "重要提示",
        Selection: "選擇表格",
        PartA: "「功績榮譽獎勵計劃」提名表",
        PartB: "校長服務記錄表",
        Confirmation: "確認",
    },
    errorMsg: {
        yearThree: "同一年度最多允許填寫三個活動",
        conflict: "服務日期不能重叠",
        year: "獲獎年份不得晚於{{year}}年",
        natureWork: "此字段僅允許輸入1或者2",
        position: "字數不多於100字",
        serviceYearTotal: "服務年數總計不能低於{{year}}年",
        avoidDuplicate: "請不要與【II. 提名獲獎項目】中的選擇重復",
        notSame: "請不要選擇相同的年份",
    },
    importantNotes: [
        "教育局會利用本表格所載的個人資料，作處理有關功績榮譽獎勵計劃的相關事宜的用途。",
        "申請人必須在本表格上填寫個人資料。申請人如不提供這些資料，申請的處理工作及結果或會受影響。",
        "本表格所蒐集的個人資料，或會向其他獲授權的政府決策局／部門／機構披露作上述用途。",
        "根據《個人資料（私隱）條例》，第18和22條及附表1保障資料第6原則的規定，你有權要求查閱及改正你的個人資料。要求查閱的權利，包括要求提供本表格所載個人資料的副本，但須繳付費用。",
        "如欲查詢有關本表格所蒐集的個人資料，包括要求查閱及改正資料事宜，需透過電郵（<a href='mailto:info_cyc@edb.gov.hk'>info_cyc@edb.gov.hk</a>）向教育局延伸支援計劃組提出。",
        "獲提名參加者有權根據《個人資料（私隱）條例》（香港特別行政區法例第 <b>486</b> 章）第 <b>18</b> 和 <b>22</b> 條，以及附表 <b>1</b> 第 <b>6</b> 項原則規定，查閱和更正所提供的個人資料。如對參加交流團所收集的個人資料有任何查詢，包括查閱及更正資料，請聯絡香港灣仔皇后大道東 <b>213</b> 號胡忠大廈 <b>11</b> 樓 <b>1141</b> 室教育局公益少年團辦事處（電話：<b>2892 6660</b>）。",
    ],
    label: {
        notes: "個人資料收集聲明",
        PersonalInfo: "個人資料",
        Nominate: "提名獲獎項目",
        ServiceRecord: "服務記錄",
        GainedRewards: "曾獲頒授之公益少年團功績榮譽獎（如有）",
        OtherReason: "其他有關值得提名的原因（如有）",
        PrincipleInfo: "校長資料",
        GainedRewardsA: "曾獲頒授之公益少年團功績榮譽獎",
        positionOption: {
            teacher: "教師",
            manager: "主任",
            vicePrincipal: "副校長",
            socialWorker: "社工",
            others: "其他",
        },
        positions: {
            chairman: "主席",
            viceChairman: "副主席",
            secretary: "秘書",
            cashier: "司庫",
            committee: "委員",
        },
        rewardOption: {
            appreciationOneYear: "感謝狀（已服務一年）",
            appreciationTwoYear: "感謝狀（已服務二年）",
            appreciationThreeYear: "嘉許狀（已服務三至四年）",
            specialOneYear: "嘉許狀（只服務一、兩年但獲特殊破格提名）",
            appreciationFiveYear: "忠誠服務獎（已服務不少於五年）",
            appreciationSevenYear: "良好服務獎（已服務不少於七年）",
            appreciationTenYear: "優異服務獎（已服務不少於十年）",
            appreciationFifteenYear: "銅章（已服務不少於十五年）",
            appreciationTwentyYear: "銀章（已服務不少於二十年）",
            noAwards: "獲提名人未曾領取任何獎項",
        },
        rewardAOption: {
            appreciationFiveYearA: "忠誠服務獎（已服務不少於五年）",
            appreciationSevenYearA: "良好服務獎（已服務不少於七年）",
            appreciationTenYearA: "優異服務獎（已服務不少於十年）",
            appreciationThirteenYearA: "銅章（已服務不少於十三年）",
            appreciationSixteenYearA: "銀章（已服務不少於十六年）",
            appreciationYearA: "金章（由本團會長審核及頒贈）",
            noAppreciation: "本人未曾領取任何獎項",
        },
        rewardYearOption: {
            appreciationOneYear: 1,
            appreciationTwoYear: 2,
            appreciationThreeYear: 3,
            specialOneYear: 1,
            appreciationFiveYear: 5,
            appreciationSevenYear: 7,
            appreciationTenYear: 10,
            appreciationFifteenYear: 15,
            appreciationTwentyYear: 20,
        },
        rewardAYearOption: {
            appreciationFiveYearA: 5,
            appreciationSevenYearA: 7,
            appreciationTenYearA: 10,
            appreciationThirteenYearA: 13,
            appreciationSixteenYearA: 16,
        },
        selectionOption: {
            partA: "公益少年團「功績榮譽獎勵計劃」提名表",
            partB: "公益少年團「功績榮譽獎勵計劃」校長服務記錄表",
        },
        titleOption: {
            Mr: "先生",
            Miss: "小姐",
            Ms: "女士",
            Dr: "博士",
        },
        titleOptionE: {
            Mr: "Mr",
            Miss: "Miss",
            Ms: "Ms",
            Dr: "Dr.",
        },
        serviceYear: "甲. 服務年數",
        excellentService: "乙. 服務期間，表現優異的項目",
        nominate: "提名獲獎項目",
        nomineeTitle: "獲提名人稱謂",
        nomineeName: "獲提名人中文姓名",
        principleTitle: "校長稱謂",
        principleName: "校長姓名",
        position: "職銜",
        specify: "請註明職銜",
        schoolName: "學校",
        schoolAddress: "學校地址",
        schoolTel: "學校電話",
        schoolFax: "傳真號碼",
        district: "所屬分區",
        startServiceDate: "開始服務日期",
        endServiceDate: "結束服務日期",
        activity: "校本／區本／中央項目",
        activityPosition:
            "具體工作崗位、貢獻（如負責教師、學員訓練、項目統籌）",
        startProjectDate: "項目開始日期",
        endProjectDate: "項目結束日期",
        rewardYear: "獲獎年份",
        otherReason: "其他有關值得提名的原因（如有）",
        proofDoc: "獎項證明文件",
        proofDocTitle: "獎項證明文件",
        proofDocText: "獎項證明文件只接受：.pdf，.png，.jpg，.doc",
        nominateTooltip: "獲提名人的服務記錄請詳列於 III.服務記錄",
        serviceYearTooltip: "以學年計算，不包括服務中斷年份",
        total: "共",
        year: "年",
        month: "個月",
        annex: "（提名細則，請參閱【附件一】）",
        title: "﹝服務年資以截至2020／21學年完結為止計算，例：如於2020年9月開始服務，即可提名服務一年感謝狀﹞",
        nomineeTitleE: "獲提名人英文稱謂",
        nomineeNameE: "獲提名人英文姓名",
        autoGenerate: "自動填寫",
        title1: "：（以下各項如有需要可另紙書寫或夾附資料）",
        title2: "﹝服務年資以截至2020／21學年完結為止計算，例：如於2020年9月開始服務，可填2020／9至2021／8共1年0月﹞",
        statement: "個人資料收集聲明",
        yearA: "截至",
        year1: "年度為止（以學年計算），本人擔任本團會員學校導師及校長合共_______年，當中不包括中斷年份。",
        countYear: "﹝例：如於2020年9月開始擔任，即填1年﹞",
        title2A:
            "最近三年擔任本團分區執行委員會職務（在適當位置加「√」）（如有）",
        title3: "最近三年統籌區本活動記錄（如有）",
        annual: "年度",
        activityName: "活動名稱",
        jobCategory: "工作性質",
        jobCategoryOption: {
            1: "總負責人",
            2: "協助",
        },
        post: "職務",
        totalA: "合共",
        principleTitleE: "校長英文稱謂",
        principleNameE: "校長英文姓名",
    },
    dataList: [
        {
            text: "教育局會利用本表格所載的個人資料，作以下其中一種或多種用途︰",
        },
        {
            text: "辦理與聘用有關的事宜；",
        },
        {
            text: "處理發放薪金津貼，以及計算公積金的供款和贈款；",
        },
        {
            text: "進行核數工作；",
        },
        {
            text: "進行研究及統計資料，以便規劃教育服務；",
        },
        {
            text: "處理有關教育專業人員發展的事宜；",
        },
        {
            text: "執行《教育條例》、《教育規例》及附屬《補助/津貼學校公積金規則》(第279章)。",
        },
        {
            text: "申請人必須在本表格上填寫個人資料。申請人如不提供這些資料，申請的處理工作及結果或會受影響。",
        },
        {
            text: "本表格所蒐集的個人資料，或會向其他獲授權的政府決策局/部門/機構披露作上述用途。",
        },
        {
            text: "根據《個人資料(私隱)條例》，第18和22條及附表1保障資料第6原則的規定，你有權要求查閱及改正你的個人資料。要求查閱的權利，包括要求提供本表格所載個人資料的副本，但須繳付費用。",
        },
        {
            text: "如欲查詢有關本表格所蒐集的個人資料，包括要求查閱及改正資料事宜，需以書面方式向教育局提出。",
        },
    ],
    symbolList: [
        { text: "(a)" },
        { text: "(b)" },
        { text: "(c)" },
        { text: "(d)" },
        { text: "(e)" },
        { text: "(f)" },
    ],
    tooltipList: {
        tableTooltip: {
            tooltip001: "校本/區本/中央項目",
            tooltip002: "日期",
            tooltip003: "具體工作崗位、貢獻（如負責教師、學員訓練、項目統籌）",
            tooltip004:
                "例：策劃本校團員歷年的社區服務活動項目包括：________________（校本）",
            tooltip005: "7-12/4/{{year}}",
            tooltip006: "公益少年團導師，積極策劃、檢討、發展本校團務工作",
            tooltip007: "例：公益少年團某區周年頒獎禮（區本）",
            tooltip008: "15/9/{{year}}",
            tooltip009: "計劃統籌，節目策劃及人手調動",
            tooltip010: "例：公益少年團傑出團員海外交流團（中央）",
            tooltip011: "7/{{year}}",
            tooltip012: "領隊教師、參與團員出發前訓練",
        },
        otherTooltip: {
            tooltip013: "示例 1：",
            tooltip014:
                "公益少年團xx區周年頒獎禮（區本）擔任計劃統籌，節目策劃及人手調動，使典禮成功完成，獲區委一致好評。",
            tooltip015: "示例 2：",
            tooltip016:
                "擔任公益少年團導師（校本），期間使團員增長率提高兩倍，至xxx人，組織及訓練團員策劃社區服務x次，使學生領導及組織能力提升，信心得以建立。",
        },
    },
    districtOption: {
        CW: "中西區",
        HKE: "東區",
        SOU: "南區",
        I: "離島區",
        WCH: "灣仔區",
        KC: "九龍城區",
        KT: "觀塘區",
        SSP: "深水埗區",
        WTS: "黃大仙區",
        YTM: "油尖旺區",
        KWT: "葵青區",
        TW: "荃灣區",
        YL: "元朗區",
        TM: "屯門區",
        N: "北區",
        SK: "西貢區",
        ST: "沙田區",
        TP: "大埔區",
    },
};
export default Form002TC;
